// Virtual iPad (0028). English counterpart of virtualDevice.nl.ts.
export const appVirtualDeviceEn = {
    title: 'Virtual iPad',
    intro: 'The real family board, exactly as on the tablet on the wall.',
    entry: 'Virtual iPad',
    entryBody: 'The board in your browser, to look around and try things.',
    orientation: 'Orientation',
    landscape: 'Landscape',
    portrait: 'Portrait',
    zoom: 'Size',
    fit: 'Fit',
    actual: '100%',
    profile: 'Tablet of',
    roomEveryone: '{room}, everyone',
    roomMembers: '{room}, {names}',
    ownWindow: 'Own window',
    ownWindowLabel: 'Open the virtual iPad in its own window of 1024 by 768',
    pairTitle: 'Pair this virtual iPad',
    pairBody: 'It becomes a tablet of its own in your family. You will find it under Tablets, where you can unpair it.',
    pairButton: 'Pair',
    pairWaiting: 'The board is making a pairing code…',
    pairedToast: 'Virtual iPad paired',
    status: '{name} in {room}',
    moved: 'The board now shows the tablet of {room}',
    revoke: 'Unpair',
    revokeTitle: 'Unpair the virtual iPad?',
    revokeBody: 'The board in your browser shows a pairing code again. Your real tablets are not affected.',
    revoked: 'Virtual iPad unpaired',
    hint: 'Every click is a tap. Sound and read-aloud work after your first click on the board, just like on the iPad.',
    storageTitle: 'This browser does not keep the pairing inside the page',
    storageBody: 'Some browsers (often Safari) keep an embedded board separate. Open the iPad in its own window: it stays paired there.',
    popupBlocked: 'Your browser blocked the window. Allow pop-ups for this site and try again.',
    frameTitle: 'Family board on the virtual iPad',
    foreignTitle: 'This board is paired as {name}, a regular tablet',
    foreignBody: 'You opened the board directly in this browser before. Pair it again as a virtual iPad: {name} will then be unpaired.',
    foreignButton: 'Pair again as a virtual iPad',
    foreignOtherTitle: 'This board belongs to another family',
    foreignOtherBody: 'This browser is paired as a tablet of another family. Unpair it there under Tablets, or open this page in a private window.',
    foreignStatus: '{name} in {room} (regular tablet)',
    stuckTitle: 'The board is not responding',
    stuckBody: 'Reload the board. If it stays empty, open it in its own window.',
    stuckReload: 'Reload',
    tag: 'Virtual',
    openOnDevice: 'Open',
};
//# sourceMappingURL=virtualDevice.en.js.map